/**
 * @nubeteck/formeck (0.19.5)
 * Copyright (c) Nubeteck, SRL.
 */
import { j as d } from "../../chunks/jsx-runtime.BwWtxLpl.js";
import t from "react";
import g from "../../utils/warning.js";
import { N as C } from "../../chunks/constants.CLW3UOOg.js";
const o = {
  lang: "es",
  decimalScale: 2,
  currencyIso: "DOP",
  inputSize: "middle",
  intlErrorFn: (e) => e
}, i = t.createContext({
  addConfig: () => null,
  ...o
}), I = () => t.useContext(i), m = () => {
  if (typeof window < "u" && window.localStorage) {
    const e = window.localStorage.getItem(
      C
    );
    if (typeof e == "string")
      return JSON.parse(e);
  }
  return {};
}, S = ({ configs: e, children: s }) => {
  const [n, a] = t.useState(
    Object.assign(o, e, m())
  ), l = t.useCallback(
    (r, f) => {
      r.includes("internal") && g("You cannot update an internal property."), a((u) => ({ ...u, [r]: f }));
    },
    []
  ), c = t.useMemo(() => Object.keys(n ?? {}).length ? n ?? {} : o, [n]);
  return /* @__PURE__ */ d.jsx(
    i.Provider,
    {
      value: { ...c, addConfig: l },
      children: s
    }
  );
};
export {
  S as default,
  I as useFormeckConfig
};
